<template>
    <div class="form-page list-forms">
        <div class="row pb-3">
            <div class="d-none d-lg-inline col-md-6">
                <h2>Forms sent</h2>
            </div>
            <div class="col-12 col-lg-6 filter__cancelled-toggle" v-bind:class="{'filter__cancelled-toggle--on' : hideCompletedForms}">
                <span>Hide completed / cancelled forms</span>
                <i v-if="hideCompletedForms" v-on:click="toggleHideCompletedForms(false)" class="fas fa-toggle-on"></i>
                <i v-if="!hideCompletedForms" v-on:click="toggleHideCompletedForms(true)" class="fas fa-toggle-off"></i>
            </div>
        </div>
            <!-- <div class="scrollable">
        <div class="scrollable-header">
            <div class="scrollable-header-content">
                <h2 class="d-none d-lg-inline">Forms sent</h2>
                <div class="filter__cancelled-toggle" v-bind:class="{'filter__cancelled-toggle--on' : hideCompletedForms}">
                    <span>Hide completed / cancelled forms</span>
                    <i v-if="hideCompletedForms" v-on:click="toggleHideCompletedForms(false)" class="fas fa-toggle-on"></i>
                    <i v-if="!hideCompletedForms" v-on:click="toggleHideCompletedForms(true)" class="fas fa-toggle-off"></i>
                </div>
            </div>
        </div> -->

        <div class="tabular-container">
            <table class="tabular">
                <thead>
<!--                    <th class="head-cnt"></th>-->
                <th class="head-sent">
                    <span class="d-inline d-sm-none"><i class="fas fa-envelope"></i></span>
                    <span class="d-none d-sm-inline">Invite Sent</span>
                </th>
                <th class="head-guest">
                    <span class="d-inline d-sm-none"><i class="fas fa-user"></i></span>
                    <span class="d-none d-sm-inline">Guest</span>
                </th>
                <th class="head-title">
                    Form
                    <!-- <span class="d-inline d-sm-none"></span>
                    <span class="d-none d-sm-inline">Title</span> -->
                </th>
                <th class="head-in">
                    <span class="d-none d-sm-inline">Check</span> In
                </th>
                <th class="head-out">
                    <span class="d-none d-sm-inline">Check</span> Out
                </th>
                <th class="head-actions text-center">
<!--                        <span class="d-none d-sm-inline">Edit/View</span>-->
                </th>
                </thead>
                <template v-if="formResponses">
                    <FormSummary v-for="(formResponse, index) in this.formResponses.content" v-bind:key="formResponse.reference"
                                    v-bind:formResponse="formResponse" v-bind:index="index">
                    </FormSummary>
                </template>
            </table>
            <div v-show="loading">
                <Spinner/>
            </div>
            <div v-show="!loading">
                <div v-if="!hasForms" class="text-center">-- No forms have been sent yet --</div>
                <div v-if="loadMoreResponses" class="load-more">
                    <button class="btn btn-secondary center" v-on:click="moreForms">More</button>
                </div>
            </div>
        </div>

        <div v-if="showTripDetails">
            <TripDetails v-bind:booking="this.trip"></TripDetails>
        </div>
    </div>
</template>

<script>
    import Spinner from '../components/Spinner.vue'
    import FormSummary from "../components/forms/FormSummary.vue"
    import TripDetails from "../components/bookings/TripDetails.vue"
    import { store } from '../store.js'

    export default {
        name: "ListForms.vue",
        components: { Spinner, FormSummary, TripDetails },
        data: function () {
            return {
                formResponses: null,
                loading: true,
                pageNumber: 0,
                pageSize: 10,
                hideCompletedForms: false,
                showTripDetails: false,
                trip: null,
            }
        },
        computed: {
            hasForms: function() {
                return this.formResponses !== null && this.formResponses.content.length > 0;
            },
            loadMoreResponses: function () {
                if (this.formResponses !== null) {
                    return this.pageNumber+1 < this.formResponses.totalPages
                }
                return false
            }
        },
        methods: {
            fetchForms: function (callback) {
                this.loading = true;
                let params = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize
                };
                if (this.hideCompletedForms) {
                    params.excludeCompleted = true;
                }
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/forms', {
                    params,
                    withCredentials: true
                }).then(response => {
                    callback(response.data)
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loading = false
                })
            },
            fetchFirstPageOfForms: function() {
                this.fetchForms((pageOfForms) => {
                    console.log(pageOfForms)
                    this.formResponses = pageOfForms
                })
            },
            moreForms: function () {
                this.pageNumber++;
                console.log("fetching page: " + this.pageNumber)
                this.fetchForms((pageOfForms) => {
                    console.log(pageOfForms)
                    this.formResponses.content.push(...pageOfForms.content)
                })
            },
            toggleHideCompletedForms: function(hide) {
                this.pageNumber = 0;
                this.hideCompletedForms = hide;
                this.fetchFirstPageOfForms();
            },
            showTrip: function (booking) {
                this.trip = booking;
                this.showTripDetails = true;
            },
            hideTrip: function () {
                this.showTripDetails = false;
                this.trip = null;
            }
        },
        mounted() {
            console.log("Loading forms");
            this.fetchFirstPageOfForms();

            this.$root.$on('selected-establishment', this.fetchFirstPageOfForms);
            this.$root.$on('show-trip', this.showTrip);
            this.$root.$on('finished-viewing-trip-details', this.hideTrip);
        },
        beforeDestroy () {
            this.$root.$off('selected-establishment', this.fetchFirstPageOfForms);
            this.$root.$off('show-trip', this.showTrip);
            this.$root.$off('finished-viewing-trip-details', this.hideTrip);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/layout/_filter";
    @import "../styles/pages/_list-forms";
</style>